export default Object.freeze({
  activeIRsGroupedByType: [],
  irsGroupedByDateAndType: [],
  irsGroupedByDate: [],
  loading: true,
});
